'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Img = require('../../01.atoms/Img/Img.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-collage-text',
    cnMirror = "".concat(CLASSNAME, "--mirror"),
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCol = "".concat(CLASSNAME, "__col"),
    cnColFirst = "".concat(cnCol, " ").concat(cnCol, "--first"),
    cnColLast = "".concat(cnCol, " ").concat(cnCol, "--last"),
    cnColText = "".concat(cnCol, " ").concat(cnCol, "--text"),
    cnImage = "".concat(CLASSNAME, "__image");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function CollageText(_ref) {
  var animate = _ref.animate,
      className = _ref.className,
      content = _ref.content,
      images = _ref.images,
      mirror = _ref.mirror,
      title = _ref.title;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, cnMirror, mirror))
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnColFirst
  }, /*#__PURE__*/React__default.createElement(Img, {
    srcset: images[0],
    alt: images[0].alt,
    className: cnImage,
    animate: animate
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: cnRow
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnColText
  }, title && /*#__PURE__*/React__default.createElement("h2", null, title), content && /*#__PURE__*/React__default.createElement("p", null, content)), /*#__PURE__*/React__default.createElement("div", {
    className: cnColLast
  }, /*#__PURE__*/React__default.createElement(Img, {
    srcset: images[1],
    alt: images[1].alt,
    className: cnImage,
    animate: animate
  }))));
}
CollageText.propTypes = {
  /** True if should be animated */
  animate: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** Content text */
  content: PropTypes.string.isRequired,

  /** Array of images */
  images: PropTypes.arrayOf(PropTypes.shape({
    xs: PropTypes.string.isRequired,
    alt: PropTypes.string
  })).isRequired,

  /** True if should be mirrored */
  mirror: PropTypes.bool,

  /** Headline */
  title: PropTypes.string.isRequired
};
CollageText.defaultProps = {
  images: []
};

module.exports = CollageText;
